const OFFICE_TYPES = {
  SERVICE_POINT: 10,
  AGENCY: 20,
  SERVICE_DESK_EXPRESS_EASY: 30,
  SERVICE_DESK_FULL_SCOPE: 40,
};

export default OFFICE_TYPES;
